module.exports = __webpack_public_path__ + "static/media/zuppler-chef.344030d0.svg";